<template>
  <v-app color="black">
    <v-main>

        <router-view />

    </v-main>
  </v-app>
</template>

<script>

export default {
  name: "App",

  components: {
  },

  data: () => ({
    //
  }),
};
</script>

<style scoped>
#app {
  background: #F5F5F5;
  background-size: contain;
    
  /* no-repeat center center fixed !important; */  
  /* padding: env(safe-area-inset); */
  /* Padding extra für iPhoneX+ im landscape */

    padding: 0px;
    padding-left: env(safe-area-inset-left);
    padding-right: env(safe-area-inset-right);
}


</style>